import React, { Component } from 'react'
import logo from "../assets/images/logo.png"
import Share from "./Helper/Share";





export default class Header extends Component {
  render() {
    
    const {isResult} = this.props;

    return (

        <header id={isResult ? "start": ""}>
         
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-6 col-sm-6 col-6">
                                    <div className="logo">
                                        <a href="https://www.rehabmart.com" target="_blank" rel="noopener noreferrer">
                                        <img src={logo} alt="logo" className="img-fluid"/>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-6 text-right">
                                    <Share/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           
    </header>

          
    )
  }
}
